var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 740.24496,
    height: 712.81799,
    viewBox: "0 0 740.24496 712.81799",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      userSelect: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b95fdd39-fb5a-4a72-9890-fbc16aea09e3",
    "data-name": "Group 193",
    style: {
      userSelect: "auto"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "fe98ab94-e9cb-45d5-93d2-a323ca3f1bc1",
    "data-name": "Group 191",
    style: {
      userSelect: "auto"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "af195c9f-bb19-4a02-bf73-25c746785d44-178",
    "data-name": "Path 5",
    d: "M403.38155,575.156a10.819,10.819,0,0,1-19.58-8.858l-41.809-85.893,20.013-12.136,36.107,91.236q.20691.08.408.169.201.089.4.184l.4.2a4.05494,4.05494,0,0,1,.39.223,10.832,10.832,0,0,1,3.678,14.868Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#feb8b8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b7be7d01-601a-466d-ae41-9577dbbca8ac-179",
    "data-name": "Path 8",
    d: "M349.9735,513.524l29.7-7.613s-.97-2.192-2.546-5.824-3.778-8.7-6.255-14.446-5.225-12.174-7.91-18.525-5.3-12.625-7.494-18.063-4.7-8.7-7.207-10.521a9.909,9.909,0,0,0-7.283-1.936,14.07409,14.07409,0,0,0-5.635,2.145,15.33789,15.33789,0,0,0-2.262,1.717l-6.886,12.523Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b3095e15-ab7d-4e65-96a4-41698fa4f221-180",
    "data-name": "Path 1-2",
    d: "M320.45852,744.87l18.176-.071-5.861,47.494-12.315.062Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#feb8b8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a302ec2b-66fd-4123-9cb3-cd16e4233762-181",
    "data-name": "Path 2",
    d: "M317.31856,804.304l39.687-.21v-.5a15.56659,15.56659,0,0,0-.3-3.034,15.1769,15.1769,0,0,0-2.288-5.513,15.5855,15.5855,0,0,0-4.292-4.271,15.186,15.186,0,0,0-5.525-2.264,15.56742,15.56742,0,0,0-3.036-.28h0l-24.25.119Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "aeeb1cd5-fa3a-4274-bafd-7f40084de8d2-182",
    "data-name": "Path 3",
    d: "M378.65651,744.646l18.124-.071-5.842,47.429-12.281.062Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#feb8b8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba1e98ed-d8f2-43c1-be39-19244e87f429-183",
    "data-name": "Path 4",
    d: "M375.52555,803.996l39.583-.208v-.5a15.57351,15.57351,0,0,0-.3-3.029,15.16818,15.16818,0,0,0-2.282-5.506,15.5376,15.5376,0,0,0-4.282-4.267,15.12869,15.12869,0,0,0-5.51-2.259,15.5001,15.5001,0,0,0-3.028-.279h0l-24.183.118Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a155f794-21b2-443d-9e35-67d51870e068-184",
    "data-name": "Path 6",
    d: "M379.42653,550.526l30.477,113.737L398.74752,773.289l-24.7.681,5.378-98.444-30.815-49.129-6.683,148.242-22.40906-1.583-12.461-127.459a144.74118,144.74118,0,0,1-9.256-30.992,138.00352,138.00352,0,0,1-2.19-25.321,118.40513,118.40513,0,0,1,1.314-17.073,62.49877,62.49877,0,0,1,1.231-6.26l9.087-9.212Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "fa92fe00-8265-4df9-92a2-5e4b8684f88d-185",
    "data-name": "Path 2616",
    d: "M339.04653,569.549c5.125,0,9.935-.164,14.3-.489a107.34218,107.34218,0,0,0,13.268-1.746,47.24629,47.24629,0,0,0,10.821-3.407,17.36384,17.36384,0,0,0,7.019-5.539l.208-.3-8.33-54.214-8.983-60.957a16.613,16.613,0,0,0-16.95-14.2l-28.134.862a15.768,15.768,0,0,0-15.27771,16.24346q.00723.23794.02173.47555l3.693,60.622-13.623,59.8.965.135c.388.051,1.883.249,4.225.512,3.061.344,6.187.654,9.29.922,4.39.378,8.687.676,12.769.885C329.50155,569.416,334.46352,569.544,339.04653,569.549Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a02ac6ff-2f2c-46ae-a320-a92bb579f594-186",
    "data-name": "Path 9",
    d: "M354.6585,417.927h.022a4.5,4.5,0,0,0,4.492-4.5V388.346a33.52171,33.52171,0,0,0-2.644-13.082,34.06094,34.06094,0,0,0-17.9-17.99,33.54,33.54,0,0,0-46.761,30.772v25.121a4.49933,4.49933,0,0,0,.356,1.76,4.576,4.576,0,0,0,2.41,2.416,4.51809,4.51809,0,0,0,1.761.363l58.264.221Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9c6a018-88fd-40d4-8b44-5495c2df83a6-187",
    "data-name": "Ellipse 1",
    d: "M310.32753,379.744a24.725,24.725,0,0,0,28.59,35.616,24.437,24.437,0,0,0,14.702-11.777,24.725,24.725,0,0,0-28.571-35.606,24.43709,24.43709,0,0,0-14.719,11.768Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#feb8b8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5ddc204-0839-488c-806a-2c44d9da4652-188",
    "data-name": "Path 10",
    d: "M367.1285,390.388a26.51672,26.51672,0,0,0-2.092-10.346,26.927,26.927,0,0,0-14.152-14.224,26.52892,26.52892,0,0,0-10.346-2.144l-5.02-.025h-.169a26.472,26.472,0,0,0-26.455,26.488v.5l10.62.043,3.621-10.117.724,10.137,5.485.024,1.826-5.1.366,5.111,35.587.159Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b53d3ad0-d874-44f4-8830-ebcf508c0715-189",
    "data-name": "Path 11",
    d: "M409.88453,443.154a11.652,11.652,0,0,1,4.48,2.2,11.34279,11.34279,0,0,1,2.6,2.917,11.83813,11.83813,0,0,1,1.711,7.385,11.33813,11.33813,0,0,1-1.046,3.761,11.529,11.529,0,0,1-16.556,4.856q-.153-.1-.3-.2-.14694-.1-.294-.207-.145-.106-.286-.215t-.279-.222l-58.6,20.857a8.832,8.832,0,0,1-10.129-3.164L317.2865,461.885l16.8-11.311,8.812,10.011,53.632-10.669q.08808-.209.182-.415t.2-.411q.1-.2.214-.406t.233-.4a11.52,11.52,0,0,1,12.527-5.128Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#feb8b8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea3ff0db-56f9-49fe-a255-68dfaf7efedd-190",
    "data-name": "Path 12",
    d: "M341.95354,454.268c-1.753-2.188-4.2-5.028-6.694-7.846s-5.017-5.61-6.924-7.7-3.189-3.473-3.189-3.473a13.81,13.81,0,0,0-25.087,10.189,13.61014,13.61014,0,0,0,2.06,5.048s1.912,2.5,4.8,6.236,6.747,8.706,10.642,13.648,7.828,9.859,10.86,13.488,5.167,5.974,5.467,5.773l10.577-31.442C344.76452,457.987,343.70653,456.456,341.95354,454.268Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9611ebe-3bd3-473e-9d8d-437c05f39574-191",
    "data-name": "Path 13",
    d: "M335.67455,417.136a4.42316,4.42316,0,0,1-.186,2.428,4.52306,4.52306,0,0,1-.593,1.114,4.57375,4.57375,0,0,1-.734.79,4.487,4.487,0,0,1-2.916,1.06q-.1,0-.2-.006t-.2-.014q-.1-.008-.2-.022t-.2-.032l-3.769-.685-5.192-11.092v10.16l-17.138-3.085V374.636l28.73.138-.71.825a19.76,19.76,0,0,0-4.474,9.724,32.21134,32.21134,0,0,0,.207,10.957,58.099,58.099,0,0,0,3.059,10.7,85.61077,85.61077,0,0,0,4.086,8.97A4.51463,4.51463,0,0,1,335.67455,417.136Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "b86d4de9-0cff-4c8a-ba1d-90db5f791b61-192",
    "data-name": "Path 2533",
    d: "M969.03154,806.409h-739.154v-2.105h740.245Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#cacaca",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a91d7220-8c5a-4469-a964-f9fb6eeff2ab-193",
    "data-name": "Path 339",
    d: "M773.11253,262.483h-3.9V155.506a61.915,61.915,0,0,0-61.915-61.915h-226.65a61.915,61.915,0,0,0-61.916,61.914V742.389a61.915,61.915,0,0,0,61.915,61.915h226.648a61.915,61.915,0,0,0,61.915-61.915V338.631h3.9Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf5182e6-9a46-4ce3-a6bb-8e5b95c0b95d-194",
    "data-name": "Path 340",
    d: "M756.58555,151.359V746.534a46.959,46.959,0,0,1-46.942,46.952h-231.3a46.966,46.966,0,0,1-46.973-46.952V151.359a46.965,46.965,0,0,1,46.971-46.951h28.058a22.329,22.329,0,0,0,20.656,30.74h131.868a22.329,22.329,0,0,0,20.656-30.74h30.055a46.959,46.959,0,0,1,46.951,46.942Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "befb231b-3654-4dfe-ba25-bde2f69c3c75-195",
    "data-name": "Path 45",
    d: "M596.45752,389.465a99.3,99.3,0,0,1-99.337-99.254v-.088c0-.208,0-.427.012-.635.3-54.4,44.863-98.7,99.325-98.7a99.337,99.337,0,0,1,.011,198.674h-.011Zm0-196.587a97.454,97.454,0,0,0-97.233,96.677c-.011.222-.011.4-.011.569a97.258,97.258,0,1,0,97.27-97.246h-.026Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "fe627b68-f6c4-4b39-818a-896f79516f98-196",
    "data-name": "Path 39",
    d: "M699.17953,493.908h-205.537a3.81,3.81,0,0,1-3.806-3.806V439.118a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284V439.118a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "efff077a-6dff-49bd-9bfe-dfa54dc61d00",
    "data-name": "Ellipse 5",
    cx: 290.40803,
    cy: 371.018,
    r: 15.986,
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e513cc1a-fc4f-42ad-8a97-aa208a4af049-197",
    "data-name": "Path 40",
    d: "M557.20653,453.952a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11713-.00189H557.20653Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb8a7882-db95-48e4-aaaf-3489ee3aa336-198",
    "data-name": "Path 41",
    d: "M557.20653,469.937a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00221-.11713-.0019H557.20653Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "af101daf-449f-4d16-aa98-172f4a8df39f-199",
    "data-name": "Path 42",
    d: "M699.17953,579.167h-205.537a3.81,3.81,0,0,1-3.806-3.806V524.377a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806v50.985A3.811,3.811,0,0,1,699.17953,579.167Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284V524.377a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a7593987-c694-475c-8cff-40adb8bae00c",
    "data-name": "Ellipse 6",
    cx: 290.40803,
    cy: 456.27798,
    r: 15.986,
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad8313dd-202d-4f4d-8eaf-20c5dd40192b-200",
    "data-name": "Path 43",
    d: "M557.20653,539.208a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.087-5.328H557.20653Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bde7542a-4575-40bb-a917-747fdde14d1d-201",
    "data-name": "Path 44",
    d: "M557.20653,555.197a2.66448,2.66448,0,1,0,0,5.329h125.605a2.665,2.665,0,0,0,.087-5.328H557.20653Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a41ae643-d6fa-4218-bc02-a84cd2f042d5-202",
    "data-name": "Path 39-2",
    d: "M699.17953,664.425h-205.537a3.81,3.81,0,0,1-3.806-3.806V609.635a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806V660.62a3.811,3.811,0,0,1-3.806,3.806Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284V660.62a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284V609.635a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eb2f5380-5bf4-43e0-97aa-e300553d76c9",
    "data-name": "Ellipse 5-2",
    cx: 290.40803,
    cy: 541.53701,
    r: 15.986,
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ef612e73-fc19-47d8-a2d1-12e834e71e5a-203",
    "data-name": "Path 40-2",
    d: "M557.20653,624.469a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00221-.11713-.00189H557.20653Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad1dc7cf-bcbc-43ff-98c3-5442d39a009f-204",
    "data-name": "Path 41-2",
    d: "M557.20653,640.456a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11713-.00189H557.20653Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b33d3e33-77f1-4447-818b-aa04c3ab1cfa-205",
    "data-name": "Path 2596",
    d: "M473.24651,526.066h37.893c2.37-17.488-2.859-33.814,0-45.472h-37.893Q462.54554,503.332,473.24651,526.066Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#ff6584",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "abd26155-66b6-4810-8bdf-9fb8037578d3-206",
    "data-name": "Path 2597",
    d: "M719.25752,613.813h-37.894c1.421-17.484,6-33.811,0-45.472h37.893Q729.95851,591.07606,719.25752,613.813Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "aae68d36-acd6-4520-9385-77d0caf729f0-207",
    "data-name": "Path 2597-2",
    d: "M649.16553,701.914h-37.894c1.421-17.484,6-33.811,0-45.472h37.893Q659.86651,679.177,649.16553,701.914Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b809e61f-e113-4687-852e-0d1aa1d72eef-208",
    "data-name": "Path 2595",
    d: "M647.22354,375.807a94.181,94.181,0,0,1-102.6-3.189,38.671,38.671,0,0,1,34.9-22.069h31.45795a38.626,38.626,0,0,1,36.244,25.262Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "b4b23dfd-a70a-4bfa-a0ec-e0b9fbca8bb1",
    "data-name": "Group 192",
    style: {
      userSelect: "auto"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "f2763f3e-78f9-4b43-a903-a3fe53ad4a45-209",
    "data-name": "Path 1133",
    d: "M553.54655,284.61c4.758-15.163,15.578-29.07,30.541-34.2s41.068-.335,48.125,13.894c10.169,20.507,5.6,45.62.208,67.885-2.812-.149-5.65-.266-8.5-.372l-4.026-13.419v13.287c-22.215-.687-45.343-.257-68.483.188C549.3416,316.113,548.78856,299.773,553.54655,284.61Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eecf4506-21ab-40dd-8b32-4db21377c650",
    "data-name": "Ellipse 507",
    cx: 356.27104,
    cy: 205.76199,
    r: 34.067,
    fill: "#feb8b8",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb1dea60-cbdf-449a-8984-6a3a37f92790-210",
    "data-name": "Path 1145",
    d: "M563.92754,258.308a40.308,40.308,0,0,1,61.283,35.179c-17.939.825-36.783,1.04-55.89,1.077l-4.519-11.053-2.662,11.06q-8.73294,0-17.5-.023A41.15708,41.15708,0,0,1,563.92754,258.308Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "a34394a5-3b6f-4dbd-b680-62200c75c4a0-211",
    "data-name": "Path 2352",
    d: "M904.16051,774.243a106.36059,106.36059,0,0,1-4.968,29.4c-.069.221-.142.439-.214.659h-18.543c.02-.2.04-.419.059-.659,1.236-14.213,8.364-100.716-.158-115.509C881.08251,689.335,905.59453,729.082,904.16051,774.243Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#f0f0f0",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4311caa-1619-4625-9a30-9ee577173a6d-212",
    "data-name": "Path 2353",
    d: "M901.18456,802.925c-.324.462-.662.924-1.007,1.379h-29.088c.221-.393.476-.855.772-1.379,4.806-8.674,19.029-34.6,32.233-61.487,14.189-28.889,27.206-58.873,26.11-69.726C930.54155,674.16,940.35656,748.774,901.18456,802.925Z",
    transform: "translate(-229.87752 -93.591)",
    fill: "#f0f0f0",
    style: {
      userSelect: "auto"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin2);
export default __webpack_public_path__ + "static/media/Login2.7429d761151ac9526e23ac32fa505174.svg";
export { ForwardRef as ReactComponent };